import { FormEvent, useEffect, useState } from 'react';
import { AuthStates, signInFormSchema, useAuth, useSignInMutation } from 'blick.react.utils';
import { router } from '../../router';
import { Button, Checkbox, Form, Panel } from 'rsuite';
import FormGroup from 'rsuite/esm/FormGroup';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import FormControl from 'rsuite/esm/FormControl';
import { Spinner } from 'react-bootstrap';
import "../../styles/login.less";
import { toast } from 'react-toastify';

export default function SignIn() {
    const signInMutation = useSignInMutation()

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRemember] = useState<boolean>(false);

    const auth = useAuth(router);

    useEffect(() => {
        if (!signInMutation.error || !signInMutation.error.message)
            return;
        toast.error(signInMutation.error.message);
    }, [signInMutation.error])

    async function handleSubmit(e: FormEvent<HTMLFormElement>) {

        const data = { username, password, rememberMe }
        const dataParsed = signInFormSchema.parse(data)

        await signInMutation.mutateAsync(dataParsed)
    }

    return (
        auth.status == AuthStates.Pending ?
            <div style={{ width:'100%', height: '100%', transition: '0.5s ease-in-out',
                alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center'
            }}
            >
                <Spinner style={{
                    borderWidth: '.15em', width: '25%',
                    height: 'fit-content', aspectRatio: '1 / 1' }} /> 
            </div>
            :
            <div id="loginContainer">
                <Panel id="logoLoginContainer" shaded bordered bodyFill>
                    <h3 style={{ marginTop: '.5rem', textAlign:'center' }}>Вход в Center</h3>
                    <section id="logonForm" >
                        <Form fluid onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormControlLabel>Логин</FormControlLabel>
                                <FormControl
                                    name="username"
                                    value={username}
                                    onChange={(value: string) => setUsername(value)}
                                />
                            </FormGroup>

                            <FormGroup>
                                <FormControlLabel>Пароль</FormControlLabel>
                                <FormControl
                                    name="password"
                                    type="password"
                                    value={password}
                                    onChange={(value: string) => setPassword(value)}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Checkbox checked={rememberMe} onChange={(_val: any, checked: boolean) => setRemember(checked)}>
                                    Запомнить меня
                                </Checkbox>
                            </FormGroup>
                            <FormGroup>
                                <Button className='submitLogon' type='submit' disabled={signInMutation.isPending}>
                                    Войти
                                </Button>
                            </FormGroup>
                        </Form>
                    </section>
                </Panel>
            </div>
    );
}